export enum JobApplicationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  ASSIGNED = 'ASSIGNED',
  INTERVIEW_SCHEDULED = 'INTERVIEW_SCHEDULED',
  OFFER = 'OFFER',
  HIRED = 'HIRED',
  TALENT_POOL = 'TALENT_POOL',
  KO_UNREACHABLE = 'KO_UNREACHABLE',
  KO_NOT_INTERESTED = 'KO_NOT_INTERESTED',
  KO_OFFER_REFUSED = 'KO_OFFER_REFUSED',
  KO_WRONG_NUMBER = 'KO_WRONG_NUMBER',
  KO_NOT_ELIGIBLE = 'KO_NOT_ELIGIBLE',
  KO_DUPLICATE = 'KO_DUPLICATE',
  KO_TEST = 'KO_TEST',
}

export type ComputedJobApplicationStatus = JobApplicationStatus | 'MANAGED';

export const koJobApplicationStatus: ComputedJobApplicationStatus[] = [
  JobApplicationStatus.TALENT_POOL,
  JobApplicationStatus.KO_UNREACHABLE,
  JobApplicationStatus.KO_NOT_INTERESTED,
  JobApplicationStatus.KO_OFFER_REFUSED,
  JobApplicationStatus.KO_WRONG_NUMBER,
  JobApplicationStatus.KO_NOT_ELIGIBLE,
  JobApplicationStatus.KO_DUPLICATE,
  JobApplicationStatus.KO_TEST,
];
